/**
 * Centralized Auth0 configuration.
 * Every auth callsite must use these helpers instead of constructing values inline.
 */

export const AUTH_SCOPE = 'openid profile offline_access email';

/** Absolute callback URL for Auth0 redirect_uri. */
export function getCallbackUrl(): string {
  return window.location.origin + (import.meta.env.VITE_AUTH0_REDIRECT_URI || '/callback');
}

/** Absolute URL Auth0 redirects to after logout. */
export function getPostLogoutUrl(): string {
  return window.location.origin + (import.meta.env.VITE_BASE_URL || '');
}

/** Standard authorizationParams for every loginWithRedirect / Auth0Provider. */
export function getAuthorizationParams() {
  return {
    redirect_uri: getCallbackUrl(),
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    scope: AUTH_SCOPE,
  };
}
